import React from 'react';

import {REVIEW_TYPE_OPTION_DATAS} from 'notebook/reviews/review-lifecycles/ReviewLifecycleConstants';
import {MultiValueFilter} from 'search/SearchConstants';
import pickDefined from 'util/pickDefined';

import DropdownFilterForm from './base/DropdownFilterForm';
import {BASE_FILTER_FORM_PROP_NAMES, BaseFilterFormProps, FilterStyle} from './base/FilterFormConstants';

interface ReviewLifecycleTypeFilterFormProps extends BaseFilterFormProps {
  filter: MultiValueFilter;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: MultiValueFilter) => void;
  onRemove?: () => void;
}

export default function ReviewLifecycleTypeFilterForm(
  props: ReviewLifecycleTypeFilterFormProps
): JSX.Element {
  const skeletonProps = pickDefined(props, ...BASE_FILTER_FORM_PROP_NAMES);
  return (
    <DropdownFilterForm
      {...skeletonProps}
      filterStyle={props.filterStyle}
      isMulti={true}
      onChangeValue={(value: Array<string>) => {
        props.onChangeFilter({...props.filter, value});
      }}
      onRemove={props.onRemove}
      optionDatas={REVIEW_TYPE_OPTION_DATAS}
      value={props.filter.value}
    />
  );
}
